import {IDataByDay} from "../selectors";
import { Dayjs } from 'dayjs'

export const getPreviewTaskItemData = (value: Dayjs, dataByDay: IDataByDay, isMobile: boolean = false) => {
    let currentDate = value.format('YYYY.MM.DD');

    if (!dataByDay[currentDate]) {
        return []
    }

    let result: { type: string, content: string }[] = []
    let expiredCount = dataByDay[currentDate]?.filter((val) => val.stage === 'expired')?.length;
    let newCount = dataByDay[currentDate]?.filter((val) => val.stage === 'new')?.length;

    if (expiredCount) {
        result.push({type: 'error', content: isMobile ? `${expiredCount}` : `${expiredCount} просрочено`})
    }

    if (newCount) {
        result.push({type: 'success', content: isMobile ? `${newCount}` : `${newCount} запланировано`})
    }


    return result;
};
